<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!--      <div class="col-xl-3">-->
      <!--        <BranchStatsPanel />-->
      <!--      </div>-->
      <!-- end col -->
      <div class="col-12 col-sm-12 col-md-12 col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">All Customers Accounts</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllCustomerAccountsTable></AllCustomerAccountsTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Customer Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";

export default {
  page: {
    title: "All Customer Accounts",
    meta: [{ name: "All Customer Accounts", content: window.__env.app.description }]
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
      title: "Customers Accounts",

      items: [
        {
          text: "Customer",
          href: "/"
        },
        {
          text: "Customer Accounts",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
